function HeaderContent() {
  return (
    <>
      <ul className="breadcrumb">
        <li className="breadcrumb-item">
          <a href="#/">TRAINING EVALUASI</a>
        </li>
        <li className="breadcrumb-item active">Detail</li>
      </ul>

      <h1 className="page-header">
        Training Evaluasi Level 3 Detail <small></small>
      </h1>

      <hr className="mb-4" />
    </>
  );
}

export default HeaderContent;
